import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import UserView from '../views/UserView.vue'
import CotizacionView from '../views/CotizacionView.vue'
import DetalleCotizacionView from '../views/DetalleCotizacionView.vue'
import EditarCotizacionView from '../views/EditarCotizacionView.vue'
import SolicitudInspeccionView from '../views/SolicitudInspeccionView.vue'
import DetalleSolicitudesView from '../views/DetalleSolicitudesView.vue'
import DetalleInspeccionView from '../views/DetalleInspeccionView.vue'
import InformacionGeneralInspeccionView from '../views/InformacionGeneralInspeccionView.vue'
import TarifasView from '../views/TarifasView.vue'
import RolesView from '../views/RolesView.vue'


const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView
   

  },
  {
    path: '/inicio',
    name: 'inicio',
    component: HomeView,
    meta: { requiresAuth: true}
  },
  {
    path: '/usuarios',
    name: 'usuarios',
    component: UserView,
    meta: { requiresAuth: true}
  },
  {
    path: '/cotizacion',
    name: 'cotizacion',
    component: CotizacionView,
    meta: { requiresAuth: true}
  },
  {
    path: '/mostrarcotizacion',
    name: 'mostrarcotizacion',
    component: DetalleCotizacionView,
    meta: { requiresAuth: true}
  },
  {
    path: '/solicitudinspeccion',
    name: 'solicitudinspeccion',
    component: SolicitudInspeccionView,
    meta: { requiresAuth: true}
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/editarcotizacion',
    name: 'editarcotizacion',
    component: EditarCotizacionView,
    meta: { requiresAuth: true}
  },
  {
    path: '/detallesolicitud',
    name: 'detallesolicitud',
    component: DetalleSolicitudesView,
    meta: { requiresAuth: true}
  }, 
  {
    path: '/detalleinspeccion',
    name: 'detalleinspeccion',
    component: DetalleInspeccionView,
    meta: { requiresAuth: true}
  },
  {
    path: '/informaciongeneralinspeccion',
    name: 'informaciongeneralinspeccion',
    component: InformacionGeneralInspeccionView,
    meta: { requiresAuth: true}
  },
 
  {
      path: '/roles',
      name: 'roles',
      component: RolesView,
      meta: { requiresAuth: true}
  },
  {
    path: '/gd',
    name: 'cetgd',
    component: TarifasView,
    meta: {
        requiresAuth: true,
        tipo: 'GD',
        unidad: 'kW'
    }
},
{
    path: '/codistribucion',
    name: 'cetcodistribucion',
    component: TarifasView,
    meta: {
        requiresAuth: true,
        tipo: 'CO',
        nivel: 'Distribución',
        unidad: 'kW'
    }
},
{
    path: '/cotransmision',
    name: 'cetcotransmision',
    component: TarifasView,
    meta: {
        requiresAuth: true,
        tipo: 'COT',
        nivel: 'Transmisión',
        unidad: 'MW'
    }
},
{
    path: '/cidistribucion',
    name: 'cetcidistribucion',
    component: TarifasView,
    meta: {
        requiresAuth: true,
        tipo: 'CI',
        nivel: 'Distribución',
        unidad: 'kW'
    }
},
{
    path: '/citransmision',
    name: 'cetcitransmision',
    component: TarifasView,
    meta: {
        requiresAuth: true,
        tipo: 'CIT',
        nivel: 'Transmisión',
        unidad: 'MW'
    }
}
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('accessToken');
  //const userRoles = store.state.auth.roles; // Accede al estado de los roles del usuario
  //alert(userRoles + 'roles');
  var val = !isAuthenticated;
  if (to.meta.requiresAuth == true && isAuthenticated == null ) {
    next({ name: 'login' });
  } else  /*(to.meta.requiresAuth && isAuthenticated)*/ {
    next();
  } 
});

export default router
